module.exports = __webpack_public_path__ + "static/media/icon-twitter.c9f12008.svg";